import { Type } from 'class-transformer';
import { DownloadFileDto, InvoiceBasicInfoDto, InvoiceDto, PayOrderDto, PayOrderGroup } from '../main';
import { Identifiable } from './identifiable';


export class PayOrderImportSessionDto extends Identifiable {
  @Type()
    importDate: Date;

  originalFileName: string;

  fileFormat: string;
  info: string;
  comment: string;
}

export class PayorderParseReportDto {
  totalSectionsCount: number;
  successfulParsedSectionsCount: number;
  failedParsedSectionsCount: number;
}

export class RunImportDto {
  sessionId: number;
  bankAccountId: number;
}

export class PayorderImportReportDto {
  totalPayordersCount: number;
  importedCount: number;
  skippedCount: number;
  failedCount: number;
  attachedToDraftCount: number;
  error: string;
}

export class CreatePayOrderImportSessionDto {
  importName: string;
  file: DownloadFileDto;
}


export class CheckAllRowsDto {
  sessionId: number;
  checked: boolean;
}


export type InvalidReasons = {
  // дубликат (обычно возникает, потому что часть партянки уже проимпортировано)
  hasDuplicate?: boolean;

  // дубликат в импорте
  importEntryAlreadyExists?: boolean;

  // не найден подходящий счет
  invoiceNotFound?: boolean;

  // TODO ??:
  // не найдено юрлицо в базе (плательщика или получателя)
  // сумма платежа превышает сумму счета - предупреждение бы

  receiverLegalEntityNotFound?: boolean;
  payerLegalEntityNotFound?: boolean;

  paymentAmountExceedsInvoice?: boolean;

}


export type ImportedPayorderAvailableOptions = {
  invoices: { id: number, title: string, date: Date, amount: number }[];
}

export type ImportedPayorderProps = {
  selected: boolean;
  selectedInvoiceId: number | null;
  selectedCashflowId: number | null;
  selectedGroup: PayOrderGroup | null;
}

export class UpdateImportedPayorderDto implements ImportedPayorderProps {
  id: number;
  selected: boolean;
  selectedInvoiceId: number | null;
  selectedCashflowId: number | null;
  selectedGroup: PayOrderGroup | null;
}

export class ImportedPayorderDto {
  id: number;

  importProps: ImportedPayorderProps;

  availableOptions: ImportedPayorderAvailableOptions;

  isValid: boolean;
  isTransfer?: boolean;
  invalidReasons?: InvalidReasons;
  duplicate?: Pick<PayOrderDto, 'id' | 'documentNumber'> & {invoices: Pick<InvoiceDto, 'id' | 'invoiceNumber'>[]};

  draftMatch?: Pick<PayOrderDto, 'id' | 'documentNumber' | 'paymentDate'>;
  hasMultipleDraftMatches?: boolean;

  /////////////////////////////
  paymentDescription: string;
  documentNumber: string;

  @Type()
    paymentDate: Date;

  @Type()
    withdrawDate?: Date;

  paymentAmount: number;
  payerBankAccount: string;
  payerName: string;
  payerInn: string;
  payerKpp: string;
  payerBankName: string;
  payerBankBik: string;
  payerCorrNumber: string;

  recieverBankAccount: string;
  recieverName: string;
  recieverInn: string;
  receiverKpp: string;
  receiverBankName: string;
  receiverBankBik: string;
  receiverCorrNumber: string;
}



